export const getOrderAmount = (order) => order.promoPrice > 0 ? order.promoPrice : order.itemsPrice;
